import React, { useState } from 'react';

const VirtualTourContext = React.createContext();

export const VirtualTourProvider = ({ children }) => {
  const [tourUrl, setTourUrl] = useState(null);
  const [hasLoadedCats, setHasLoadedCats] = useState(false);
  const [activeCampaign, setActiveCampaign] = useState(null);
  const [firstClick, setFirstClick] = useState(null);
  return (
    <VirtualTourContext.Provider
      value={{ 
        firstClick,
        setFirstClick,
        tourUrl, 
        setTourUrl: value => setTourUrl(value), 
        hasLoadedCats,
        activeCampaign,
        setActiveCampaign,
        setHasLoadedCats: value => setHasLoadedCats(value) }}
    >
      {children}
    </VirtualTourContext.Provider>
  );
};
export const VirtualTourConsumer = VirtualTourContext.Consumer;

export default VirtualTourContext;
